/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTerminalResponse
 */
export interface GetTerminalResponse {
    /**
     * 
     * @type {string}
     * @memberof GetTerminalResponse
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof GetTerminalResponse
     */
    company: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetTerminalResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetTerminalResponse
     */
    surchargeEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetTerminalResponse
     */
    surchargePercentage: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTerminalResponse
     */
    surchargeDisclosure: Array<string>;
}

/**
 * Check if a given object implements the GetTerminalResponse interface.
 */
export function instanceOfGetTerminalResponse(value: object): value is GetTerminalResponse {
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('surchargeEnabled' in value) || value['surchargeEnabled'] === undefined) return false;
    if (!('surchargePercentage' in value) || value['surchargePercentage'] === undefined) return false;
    if (!('surchargeDisclosure' in value) || value['surchargeDisclosure'] === undefined) return false;
    return true;
}

export function GetTerminalResponseFromJSON(json: any): GetTerminalResponse {
    return GetTerminalResponseFromJSONTyped(json, false);
}

export function GetTerminalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTerminalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'terminalId': json['terminalId'],
        'company': json['company'],
        'enabled': json['enabled'],
        'surchargeEnabled': json['surchargeEnabled'],
        'surchargePercentage': json['surchargePercentage'],
        'surchargeDisclosure': json['surchargeDisclosure'],
    };
}

export function GetTerminalResponseToJSON(json: any): GetTerminalResponse {
    return GetTerminalResponseToJSONTyped(json, false);
}

export function GetTerminalResponseToJSONTyped(value?: GetTerminalResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'terminalId': value['terminalId'],
        'company': value['company'],
        'enabled': value['enabled'],
        'surchargeEnabled': value['surchargeEnabled'],
        'surchargePercentage': value['surchargePercentage'],
        'surchargeDisclosure': value['surchargeDisclosure'],
    };
}

